import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].GET_COMPANY_FUEL_SETTINGS]: {
		url: '/company/:companyId/materials_settings/:materialsSettingsId/',
	},
	[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].PATCH_COMPANY_FUEL_SETTINGS]: {
		url: '/company/:companyId/materials_settings/:materialsSettingsId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
}
